// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"0a0a0a17","37":"037785d6"}[chunkId] + ".chunk.js";
};